import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import theme from '../../theme';
import ButtonWrapper from '../Button/ButtonWrapper';
import { ButtonProps, ButtonWrapperProps, NavItemProps } from '../../@types/';
import { DialogTitle, ListItem } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { useHistory } from 'react-router';
import PopUpDialog from '../Dialog/PopUpDialog';
import SubmitButton from '../Button/SubmitButton';
import CancelButton from '../Button/CancelButton';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles({
	listItem: {
		// paddingLeft: theme.spacing(2),
	},
	icon: {
		color: theme.palette.common.white,
	},
	special: {
		position: 'absolute',
		bottom: 0,
		paddingRight: '50px',
	},
	title: {
		textAlign: 'center',
		padding: '30px',
	},
});

const NavItem = (props: NavItemProps) => {
	const classes = useStyles();
	const history = useHistory();

	// const buttonProps: ButtonProps & ButtonWrapperProps = {
	//     message: props.text,
	//     icon: props.special ? <ExitToApp /> : '',
	//     onClick: props.onClick,
	//     className: `${classes.defaultButtonClasses} ${props.buttonClassName}`,
	//     color: theme.palette.grey[100],
	//     bgColor: props.special ? theme.palette.secondary.main : theme.palette.secondary.light,
	// }
	{
		/* <ButtonWrapper {...buttonProps} /> */
	}

	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSubmit = () => {
		setOpen(false);
		handleClicked();
	};

	const handleClicked = () => {
		if (props.onClick) {
			props.onClick();
		}
		history.push(props.path);
		// props.handleDrawerClose();
	};

	return (
		<>
			{props.special ? (
				<>
					<ListItem
						button
						className={`${props.className} ${classes.listItem} ${classes.special}`}
						onClick={handleClickOpen}
					>
						<ListItemIcon className={classes.icon}>
							{props.icon}
						</ListItemIcon>
						<ListItemText primary={props.text} />
					</ListItem>
					<Dialog
						open={open}
						// TransitionComponent={Transition}
						fullWidth
						keepMounted
						onClose={handleClose}
						aria-labelledby='alert-dialog-slide-title'
						aria-describedby='alert-dialog-slide-description'
					>
						<DialogTitle
							className={classes.title}
							id='alert-dialog-slide-title'
						>
							Are you sure you want to log out?
						</DialogTitle>
						<DialogActions>
							<Grid container justify='center' spacing={10}>
								<Grid item>
									<CancelButton
										message='Cancel'
										onClick={handleClose}
									/>
								</Grid>
								<Grid item>
									<SubmitButton
										icon={<ExitToAppIcon />}
										message='Log out'
										onClick={handleSubmit}
									/>
								</Grid>
							</Grid>
						</DialogActions>
					</Dialog>
				</>
			) : (
				<ListItem
					button
					selected={props.selectedPath === props.path}
					className={`${props.className} ${classes.listItem}`}
					onClick={handleClicked}
				>
					<ListItemIcon className={classes.icon}>
						{props.icon}
					</ListItemIcon>
					<ListItemText primary={props.text} />
				</ListItem>
			)}
		</>
	);
};

export default NavItem;
